import app from './app';
app.init();




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./public/app/index.ts